(function () {
  const SECTION_SELECTOR = '.section-wp-spare-parts';
  const CONTENT_SELECTOR = '[id^="SparePartsContent-"]';
  const pendingRequests = new WeakMap();
  let isBound = false;

  function getSectionId(sectionEl) {
    if (!sectionEl?.id) return '';
    return sectionEl.id.replace(/^shopify-section-/, '');
  }

  function getSectionUrl(variantId, sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  async function refreshSection(sectionEl, variantId) {
    const sectionId = getSectionId(sectionEl);
    if (!sectionId || !variantId) return;

    const contentEl = sectionEl.querySelector(CONTENT_SELECTOR);
    if (!contentEl) return;

    const previousController = pendingRequests.get(sectionEl);
    if (previousController) previousController.abort();

    const controller = new AbortController();
    pendingRequests.set(sectionEl, controller);

    try {
      const response = await fetch(getSectionUrl(variantId, sectionId), {
        signal: controller.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) return;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newSection = parsed.getElementById(sectionEl.id);
      const newContent = newSection?.querySelector(CONTENT_SELECTOR);
      if (!newContent) return;

      if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility?.setInnerHTML) {
        HTMLUpdateUtility.setInnerHTML(contentEl, newContent.innerHTML);
      } else {
        contentEl.innerHTML = newContent.innerHTML;
      }
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('wp-spare-parts refresh failed', error);
      }
    } finally {
      if (pendingRequests.get(sectionEl) === controller) {
        pendingRequests.delete(sectionEl);
      }
    }
  }

  function handleVariantChange(event) {
    const variantId = event?.detail?.variant?.id?.toString();
    if (!variantId) return;

    document.querySelectorAll(SECTION_SELECTOR).forEach((sectionEl) => {
      refreshSection(sectionEl, variantId);
    });
  }

  function init() {
    if (isBound) return;
    isBound = true;

    document.addEventListener('variant-change', handleVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
